import styled from '@emotion/styled';
import React, { useCallback } from 'react';
import { Box, Flex, Link, Text } from 'roo-ui/components';
import { themeGet } from 'styled-system';
import PageBlock from 'components/PageBlock';
import { useDataLayer } from 'hooks/useDataLayer';
import { QH_SELF_SERVICE_URL } from 'config';

const HeaderText = styled(Text)`
  display: block;
  font-size: ${themeGet('fontSizes.md')};
  font-weight: ${themeGet('fontWeights.bold')};
  margin-bottom: ${themeGet('space.3')};
  margin-top: ${themeGet('space.10')};
`;

const BaseText = styled(Text)`
  font-size: ${themeGet('fontSizes.base')};
`;

const Covid19Faqs = () => {
  const { emitInteractionEvent } = useDataLayer();

  const handleManageBookingLinkClick = useCallback(() => {
    emitInteractionEvent({ type: 'Manage Your Booking Link', value: 'Link Selected' });
  }, [emitInteractionEvent]);

  const selfServiceUrl = `${QH_SELF_SERVICE_URL}?source=QH-contact-us-page`;

  return (
    <PageBlock bg="white" px={[4, 6, 0]} data-print-style="page-block">
      <Flex borderBottom={1} borderColor="greys.porcelain" pb={10}>
        <Box width={[1, 0.75]}>
          <HeaderText data-testid="review-FAQs">Please review the FAQs below before getting in touch with our team.</HeaderText>
          <HeaderText data-testid="booking-refundable-question">Is your booking refundable?</HeaderText>
          <BaseText mb={4} data-testid="booking-refundable-answer">
            You can check the cancellation policy for your booking via{' '}
          </BaseText>
          <BaseText
            as={Link}
            onClick={handleManageBookingLinkClick}
            display="inline"
            href={selfServiceUrl}
            data-testid="booking-refundable-self-service-link"
          >
            Manage your booking
          </BaseText>{' '}
          <BaseText>
            in our online Self Service portal.{'  '}We recommend checking the latest status as some properties have changed booking status
            from non-refundable, to refundable in light of COVID-19.{'  '}If your booking has a flexible cancellation period, please ensure
            you cancel within the specified timeframe to secure a refund.
          </BaseText>
        </Box>
      </Flex>
    </PageBlock>
  );
};

export default Covid19Faqs;
